import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import PricingSection from "../../components/PricingSection";
import { servicesData } from "../../data/servicesData";
import ExperienceSection from "../../components/ExperienceSection";

const SITE_URL = "https://www.callsoftbd.com";

const SERVICE_KEYWORDS = {
  "web-app-development": "web development , app development Bangladesh and whole world, custom website , Next.js development Bangladesh and whole world, React developer , e-commerce website Bangladesh",
  "ui-ux-design": "UI UX design , Figma designer Bangladesh and whole world, user experience design , mobile app UI Bangladesh and whole world, web design company ",
  "cloud-devops": "cloud DevOps , Kubernetes Bangladesh and whole world, CI/CD pipeline , Docker containerization Bangladesh and whole world, DevOps engineer ",
  "vps-hosting": "VPS hosting , managed hosting Bangladesh and whole world, cPanel hosting , dedicated server Bangladesh and whole world, web hosting ",
  "aws-cloud-platforms": "AWS , Amazon Web Services Bangladesh and whole world, AWS setup , cloud architecture Bangladesh and whole world, AWS consultant ",
  "server-management": "server management , Linux admin Bangladesh and whole world, server monitoring , managed server Bangladesh and whole world, sysadmin ",
  "ai-data": "AI solutions , chatbot development Bangladesh and whole world, machine learning , data analytics Bangladesh and whole world, AI automation ",
  "cybersecurity": "cybersecurity , penetration testing Bangladesh and whole world, security audit , GDPR compliance Bangladesh and whole world, ISO 27001 ",
  "migration-maintenance": "website migration , server migration Bangladesh and whole world, site maintenance , IT maintenance Bangladesh and whole world, data migration ",
};

const allServices = [
  { slug: "web-app-development", title: "Web & App Development", icon: "fa-code" },
  { slug: "ui-ux-design", title: "UI/UX Design", icon: "fa-palette" },
  { slug: "cloud-devops", title: "Cloud & DevOps", icon: "fa-cloud" },
  { slug: "vps-hosting", title: "VPS & Hosting", icon: "fa-server" },
  { slug: "aws-cloud-platforms", title: "AWS & Cloud Platforms", icon: "fa-cloud-upload-alt" },
  { slug: "server-management", title: "Server Management", icon: "fa-cogs" },
  { slug: "ai-data", title: "AI & Data", icon: "fa-brain" },
  { slug: "cybersecurity", title: "Cybersecurity", icon: "fa-shield-alt" },
  { slug: "migration-maintenance", title: "Migration & Maintenance", icon: "fa-sync-alt" }
];

export default function ServicePage({ slug }) {
  const service = servicesData[slug];

  if (!service) {
    return (
      <div style={{ textAlign: 'center', padding: '100px 20px' }}>
        <h1>Service Not Found</h1>
        <p>The requested service does not exist.</p>
        <Link to="/">Back to Home</Link>
      </div>
    );
  }

  const canonical = `${SITE_URL}/services/${slug}`;
  const desc = service.overview.desc.substring(0, 160);
  const ogTitle = `${service.title} Services in , Bangladesh and whole world— Callsoftbd`;

  useEffect(() => {
    if (typeof window !== "undefined") {
      // Re-trigger AOS animations on route mount
      if (typeof AOS !== "undefined") {
        AOS.init({ easing: "ease-in-out-sine" });
      }
    }
  }, [slug]);

  return (
    <>
      <Helmet>
        <title>{service.title} Services in , Bangladesh</title>
        <meta name="description" content={desc} />
        <meta name="keywords" content={SERVICE_KEYWORDS[slug] || `${service.title} , IT services Bangladesh`} />
        <link rel="canonical" href={canonical} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_AE" />
        <meta property="og:url" content={canonical} />
        <meta property="og:site_name" content="Callsoftbd" />
        <meta property="og:title" content={ogTitle} />
        <meta property="og:description" content={desc} />
        <meta property="og:image" content={`${SITE_URL}/assets/img/unsplash-1518770660439-4636190af475.jpg`} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={ogTitle} />
        <meta name="twitter:description" content={desc} />
        <meta name="twitter:image" content={`${SITE_URL}/assets/img/unsplash-1518770660439-4636190af475.jpg`} />
        <meta name="twitter:creator" content="@CallsoftbdBangladesh" />
      </Helmet>

      {/* ============ PAGE HERO ============ */}
      <section
        className="page-hero"
        style={{ backgroundImage: `url('${service.heroBg}')` }}
      >
        <div className="page-hero-overlay"></div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-hero-content">
                <div className="hero-service-icon">
                  <i className={`fa ${service.heroIcon}`}></i>
                </div>
                <h1 className="page-title">{service.title}</h1>
                <nav className="breadcrumb-nav" aria-label="breadcrumb">
                  <Link to="/">Home</Link>
                  <span className="sep">/</span>
                  <Link to="/#services">Services</Link>
                  <span className="sep">/</span>
                  <span className="current">{service.title}</span>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ============ OVERVIEW SECTION ============ */}
      <section className="service-overview-section pt-60 pb-60">
        <div className="container">
          <div className="row align-items-start">
            <div className="col-lg-8 mb-4 mb-lg-0" data-aos="fade-right" data-aos-delay="100">
              <div className="overview-icon-wrap">
                <i className={`fa ${service.heroIcon}`}></i>
              </div>
              <div className="subtitle subtitle_1bececf" style={{ marginBottom: '12px' }}>
                <h4>
                  <span className="subtitle-first-span"></span>
                  <span className="subtitle-middle-span">{service.overview.title}</span>
                  <span className="subtitle-last-span"></span>
                </h4>
              </div>
              <div className="title title_1bececf" style={{ marginBottom: '16px' }}>
                <h2>
                  <span></span>
                  <span>{service.overview.desc.substring(0, 60)}...</span>
                  <span></span>
                </h2>
              </div>
              <p style={{ color: '#555', fontSize: '1.05rem', lineHeight: '1.8' }}>
                {service.overview.desc}
              </p>
              <ul className="overview-checklist">
                {service.overview.checklist.map((item, idx) => (
                  <li key={idx}>
                    <i className="fa fa-check-circle"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              <Link to="/contact" className="btn-common primary-btn global-btn-style" style={{ display: 'inline-flex' }}>
                <span>Start Your Project</span>
              </Link>
              <a href="tel:+8801839602840" className="btn-common secondary-btn global-btn-style" style={{ display: 'inline-flex', marginLeft: '12px' }}>
                <span>+880 1839-602840</span>
              </a>
            </div>

            <div className="col-lg-4" data-aos="fade-left" data-aos-delay="200">
              <div className="services-sidebar-widget">
                <div className="ssw-header">
                  <h3>
                    <i className="fa fa-th-list" style={{ marginRight: '8px', color: 'var(--color-primary, #2400A8)' }}></i>
                    All Services
                  </h3>
                </div>
                <ul className="ssw-list">
                  {allServices.map((s) => (
                    <li key={s.slug}>
                      <Link to={`/services/${s.slug}`} className={s.slug === slug ? "active" : ""}>
                        <i className={`fa ${s.icon}`}></i> {s.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="contact-widget">
                <i className="fa fa-headset cw-big-icon"></i>
                <h4>Need Help?</h4>
                <p>Talk to our experts and get a free consultation on your project.</p>
                <a href="tel:+8801839602840" className="cw-btn cw-btn-phone">
                  <i className="fa fa-phone"></i>+880 1839-602840
                </a>
                <a href="https://wa.me/8801839602840" target="_blank" className="cw-btn cw-btn-wa">
                  <i className="fab fa-whatsapp"></i>WhatsApp Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ExperienceSection />

      {/* ============ SUB-SERVICES SECTION ============ */}
      <section className="sub-services-section pt-60 pb-60">
        <div className="container">
          <div className="text-center mb-5" data-aos="fade-down">
            <div className="subtitle subtitle_1bececf">
              <h4>
                <span className="subtitle-first-span"></span>
                <span className="subtitle-middle-span">Our Capabilities</span>
                <span className="subtitle-last-span"></span>
              </h4>
            </div>
            <div className="title title_1bececf">
              <h2>
                <span></span>
                <span>What We Deliver</span>
                <span></span>
              </h2>
            </div>
          </div>
          <div className="row">
            {service.subServices.items.map((sub, idx) => (
              <div key={idx} className="col-lg-3 col-md-6 mb-4" data-aos="flip-left" data-aos-delay={(idx + 1) * 100}>
                <div className="ssc">
                  <div className="ssc-icon">
                    <i className={`fa ${service.heroIcon}`}></i>
                  </div>
                  <h3>{sub.title}</h3>
                  <p>{sub.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ PROCESS SECTION ============ */}
      <section className="process-section pt-60 pb-60">
        <div className="container">
          <div className="text-center mb-5" data-aos="fade-down">
            <div className="subtitle subtitle_1bececf">
              <h4>
                <span className="subtitle-first-span"></span>
                <span className="subtitle-middle-span">How We Work</span>
                <span className="subtitle-last-span"></span>
              </h4>
            </div>
            <div className="title title_1bececf">
              <h2>
                <span></span>
                <span>{service.process.title}</span>
                <span></span>
              </h2>
            </div>
          </div>
          <div className="row align-items-start justify-content-center">
            {service.process.steps.map((step, idx) => (
              <div key={idx} className="col-lg-3 col-md-6" data-aos="zoom-in" data-aos-delay={(idx + 1) * 100}>
                <div className="process-step-box">
                  <div className="ps-num">0{idx + 1}</div>
                  <h4>{step.title}</h4>
                  <p>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ STATS SECTION ============ */}
      <div className="stat-strip">
        <div className="container">
          <div className="row">
            <div className="col-md-4" data-aos="zoom-in" data-aos-delay="100">
              <div className="stat-item">
                <span className="stat-num">500+</span>
                <span className="stat-lbl">Projects Completed</span>
              </div>
            </div>
            <div className="col-md-4" data-aos="zoom-in" data-aos-delay="200">
              <div className="stat-item">
                <span className="stat-num">350+</span>
                <span className="stat-lbl">Happy Clients</span>
              </div>
            </div>
            <div className="col-md-4" data-aos="zoom-in" data-aos-delay="300">
              <div className="stat-item">
                <span className="stat-num">15+</span>
                <span className="stat-lbl">Years Experience</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ============ PRICING SECTION ============ */}
      <PricingSection slug={slug} />
    </>
  );
}
